import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule, MatTooltipModule } from '@angular/material';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmDeleteNewSchedulingSuggestionsComponent } from './confirm-delete-new-scheduling-suggestions/confirm-delete-new-scheduling-suggestions.component';
import { ScheduleSuggestionsComponent } from './schedule-suggestions.component';

@NgModule({
  declarations: [
    ScheduleSuggestionsComponent,
    ConfirmDeleteNewSchedulingSuggestionsComponent
  ],
  entryComponents: [
    ConfirmDeleteNewSchedulingSuggestionsComponent
  ],
  imports: [
    CommonModule,
    TranslateModule.forRoot(),
    MatTooltipModule,
    MatIconModule,
    PipesModule,
  ],
  exports: [
    ScheduleSuggestionsComponent
  ]
})
export class ScheduleSuggestionsModule { }
